import { TechnologyType } from '@@types/api.types';
import { SelectionCard } from '@components/shared/selection-card.component';
import { withForm } from '@components/ui/form/form';
import { cn } from '@lib/utils';
import { technologyFormOptions } from './technology-form-options';

const types = [
  {
    value: TechnologyType.HARDWARE,
    icon: (isSelected: boolean) => (
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('size-8', isSelected ? 'text-blue-700' : 'text-[#1F1C1A] opacity-70')}
      >
        <path
          d="M17.1925 14.2994L21.0708 18.1777C21.8518 18.9587 21.8518 20.2251 21.0708 21.0061V21.0061C20.2897 21.7872 19.0234 21.7872 18.2423 21.0061L12.0339 14.7977"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.73242 6.40375L4.6111 7.11086L2.48978 3.57533L3.904 2.16111L7.43953 4.28243L6.73242 6.40375ZM6.73242 6.40375L9.56265 9.23398"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.91769 10.7373C9.99197 10.9639 9.94141 11.2157 9.77277 11.3843L2.97934 18.1777C2.19829 18.9588 2.19829 20.2251 2.97934 21.0062C3.76039 21.7872 5.02672 21.7872 5.80777 21.0062L12.8788 13.9351C15.0319 14.7789 17.8569 14.6139 19.5964 12.8744C21.3359 11.1349 21.7177 7.92467 20.657 6.1569L17.6164 9.19758L14.5053 9.48019L14.7879 6.36915L17.8286 3.32848C16.0608 2.26782 12.8506 2.64962 11.1111 4.38914C9.46943 6.03081 9.23013 8.63928 9.91769 10.7373Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    primaryLabel: 'Hardware',
    secondaryLabel: 'Physical devices, equipment and machinery',
  },
  {
    value: TechnologyType.SOFTWARE,
    icon: (isSelected: boolean) => (
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('size-8', isSelected ? 'text-blue-700' : 'text-[#1F1C1A] opacity-70')}
      >
        <g clipPath="url(#clip0_1886_7404)">
          <path
            d="M5.74999 11L4.49999 10.5L2.56845 9.94814C2.03178 9.79481 1.97688 9.05597 2.48499 8.82501L11.7517 4.61286C11.9095 4.54115 12.0905 4.54115 12.2483 4.61286L21.3662 8.75739C21.8907 8.99576 21.8105 9.76435 21.2481 9.88932L20.75 10M5.74999 11C5.74999 11 6.5179 11.2902 7 11.5C8.69251 12.2365 10.9264 13.4216 11.712 13.8442C11.8919 13.941 12.1081 13.941 12.288 13.8442C13.0736 13.4216 15.3075 12.2365 17 11.5C17.4821 11.2902 18.25 11 18.25 11M5.74999 11L5.75 16.288C5.75 16.4252 5.79656 16.5588 5.88499 16.6636C7.47537 18.549 9.50836 19.5 12 19.5C14.4916 19.5 16.5246 18.549 18.115 16.6636C18.2034 16.5588 18.25 16.4252 18.25 16.288L18.25 11M18.25 11L19.5 10.5L20.75 10M20.75 10L20.75 14.5M20.75 14.5V15.9365M20.75 14.5L20.397 15.4238C20.3025 15.6712 20.4852 15.9365 20.75 15.9365V15.9365M20.75 14.5L21.0956 15.4414C21.1839 15.6817 21.006 15.9365 20.75 15.9365V15.9365"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1886_7404">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
    primaryLabel: 'Software',
    secondaryLabel: 'Algorithms, platforms and applications',
  },
  {
    value: TechnologyType.HYBRID,
    icon: (isSelected: boolean) => (
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn('size-8', isSelected ? 'text-blue-700' : 'text-[#1F1C1A] opacity-70')}
      >
        <path
          d="M17 4.5V2.5M12 4.5V2.5M7 4.5V2.5M7 20.5V22.5M12 20.5V22.5M17 20.5V22.5M20 17.5H22M20 12.5H22M20 7.5H22M4 17.5H2M4 12.5H2M4 7.5H2M8 9.1V15.9C8 16.2314 8.26863 16.5 8.6 16.5H15.4C15.7314 16.5 16 16.2314 16 15.9V9.1C16 8.76863 15.7314 8.5 15.4 8.5H8.6C8.26863 8.5 8 8.76863 8 9.1ZM20 19.9V5.1C20 4.76863 19.7314 4.5 19.4 4.5H4.6C4.26863 4.5 4 4.76863 4 5.1V19.9C4 20.2314 4.26863 20.5 4.6 20.5H19.4C19.7314 20.5 20 20.2314 20 19.9Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    primaryLabel: 'Hybrid',
    secondaryLabel: 'Integrated systems with Hardware and Software',
  },
];

export const TypeStep = withForm({
  ...technologyFormOptions,
  render: function Render({ form }) {
    return (
      <form.AppField name="type">
        {(field) => (
          <div className="flex flex-row items-center justify-center gap-4">
            {types.map(({ value, icon, primaryLabel, secondaryLabel }) => (
              <SelectionCard
                key={value}
                value={value}
                icon={icon}
                primaryLabel={primaryLabel}
                secondaryLabel={secondaryLabel}
                isSelected={field.state.value === value}
                onClick={() => field.handleChange(value)}
                onKeyUp={(e) => (e.key === 'Enter' || e.key === ' ') && field.handleChange(value)}
              />
            ))}
          </div>
        )}
      </form.AppField>
    );
  },
});
